import { cn } from "@/utils/cn";
import { memo } from "react";

interface GeekGlassesIconProps {
  className?: string;
}

export const GeekGlassesIcon = memo(function GeekGlassesIcon({ className }: GeekGlassesIconProps) {
  return (
    <img
      src="/assets/images/geek-glasses.svg"
      alt="Geek glasses"
      className={cn("h-[168px] w-[168px] rounded-full", className)}
    />
  );
});
